import Vue from 'vue'
import store from './store'
import Router, { RouterOptions, RouteConfig } from 'vue-router'
import Lots from '@/components/Lots.vue'
import OutstandingWorkOrders from '@/components/OutstandingWorkOrders.vue'
import WorkOrders from '@/components/WorkOrders.vue'
import WorkOrder from '@/components/WorkOrder.vue'
import Vineyards from '@/components/Vineyards.vue'
import SCPCalendar from '@/components/SCPCalendar.vue'
import WeighTags from '@/components/WeighTags.vue'
import WeighTag from '@/components/WeighTag.vue'
import BOLs from '@/components/BOLs.vue'
import LayoutTest from '@/components/LayoutTest.vue'
import SingleBOL from '@/components/BOL.vue'
import FacilityWeights from '@/components/FacilityWeights.vue'
import LabSummary from '@/components/LabSummary.vue'
import DailyWeighTags from '@/components/DailyWeighTags.vue'
import WeighTagsByVintage from '@/components/WeighTagsByVintage.vue'
import FermProtocols from '@/components/FermProtocols.vue'
import BrixTemps from '@/components/BrixTemps.vue'
import Login from '@/components/Login.vue'
import Register from '@/components/Register.vue'
import AssetSchedules from '@/components/AssetSchedules.vue'
import WOCalendar from '@/components/WOCalendar.vue'
import POPDWorkOrders from '@/components/POPDWorkOrders.vue'
import SCPsForClipboard from '@/components/SCPsForClipboard.vue'
import PressCalendar from '@/components/PressCalendar.vue'

Vue.use(Router)

const navRoutes = [
  {
    path: '/',
    component: OutstandingWorkOrders
  },
  {
    path: '/layout',
    name: 'layout',
    component: LayoutTest
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/register',
    name: 'register',
    component: Register
  },
  {
    path: '/brixtemps',
    name: 'brixtemps',
    component: BrixTemps
  },
  {
    path: '/labSummary',
    name: 'labSummary',
    component: LabSummary
  },
  {
    path: '/pressCalendar',
    name: 'pressCalendar',
    component: PressCalendar
  },
  {
    path: '/scpsForClipboard',
    name: 'scpsForClipboard',
    component: SCPsForClipboard
  },
  {
    path: '/popdWorkOrders',
    component: POPDWorkOrders
  },
  {
    path: '/woCalendar',
    component: WOCalendar
  },
  {
    path: '/fermProtocols',
    component: FermProtocols
  },
  {
    path: '/dailyWeighTags',
    component: DailyWeighTags
  },
  {
    path: '/weighTagsByVintage',
    component: WeighTagsByVintage
  },
  {
    path: '/assetSchedules',
    component: AssetSchedules
  },
  {
    path: '/lots',
    component: Lots
  },
  {
    path: '/vineyards',
    component: Vineyards
  },
  {
    path: '/weightags',
    component: WeighTags
  },
  {
    path: '/SCPCalendar',
    component: SCPCalendar
  },
  {
    path: '/bols',
    component: BOLs
  },
  {
    path: '/weightag/:id',
    component: WeighTag
  },
  {
    path: '/workorders/:lotNumber',
    component: WorkOrders
  },
  {
    path: '/bols/:id',
    component: SingleBOL
  },
  {
    path: '/facilityWeights',
    component: FacilityWeights
  },
  {
    path: '/workorder',
    component: WorkOrder
  },
  {
    path: '/workorder/:id',
    component: WorkOrder
  },
  {
    path: '/outstandingWorkOrders',
    component: OutstandingWorkOrders
  }
]

const router = new Router({
  routes: navRoutes,
  mode: 'history'
})

router.beforeEach((to, from, next) => {
  if (to.name === 'register' || to.name === 'login') {
    // here they have cliced on register or login
    next()
  } else if (store.getters.authenticatedUser === null || store.getters.authenticatedUser === undefined) {
    if (to.name === 'register') {
      next('/register')
    } else {
      next('/login')
    }
  } else {
    // authenticated user
    if (to.path === '/outstandingWorkOrders') {
      if (store.getters.user) {
        if (store.getters.user.staff) {
          next()
        } else {
          next('/lots')
        }
      } else {
        next('/lots')
      }
    } else {
      next()
    }
  }
})

export default router
